var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAvatarFemale = function SvgAvatarFemale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#avatar-female_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "#fff",
    rx: 25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#DEF4FF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB3F3A",
    d: "M25.065 6.29c.315.075.63.11.95.08 1.58-.135 6.955-.195 9.275 4.925 2.73 6.04 4.215 7.675 2.31 14.695s-.385 6.755.6 10.33l.03.105c.53 1.925-1.03 3.785-3.025 3.62l-3.815-.325a2.9 2.9 0 0 0-.825.05c-2.17.45-12.535 2.505-16.51 1.465a23 23 0 0 1-3.495-1.215c-1.66-.735-2.18-2.805-1.15-4.3.435-.625.775-1.31.845-1.965.21-2.02-1.195-3.84-.64-7.265.925-5.735 2.68-5.205 2.99-8.785.18-2.05 3.265-13.61 12.455-11.415z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB3F3A",
    d: "M25.065 6.29c.315.075.63.11.95.08 1.58-.135 6.955-.195 9.275 4.925 2.73 6.04 4.215 7.675 2.31 14.695s-.385 6.755.6 10.33l.03.105c.53 1.925-1.03 3.785-3.025 3.62l-3.815-.325a2.9 2.9 0 0 0-.825.05c-2.17.45-12.535 2.505-16.51 1.465a23 23 0 0 1-3.495-1.215c-1.66-.735-2.18-2.805-1.15-4.3.435-.625.775-1.31.845-1.965.21-2.02-1.195-3.84-.64-7.265.925-5.735 2.68-5.205 2.99-8.785.18-2.05 3.265-13.61 12.455-11.415z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB69F",
    d: "M44.895 43.9c-4.14-1.395-14.485-6.75-14.485-6.75l-.64-4.89h-9.06l-.585 4.89S9.785 42.505 5.64 43.9 1.5 52.365 1.5 52.365h47.54s0-7.07-4.14-8.465z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB69F",
    d: "M25.27 38.696c2.842 0 5.145-.692 5.145-1.545 0-.854-2.303-1.546-5.145-1.546s-5.145.692-5.145 1.546c0 .853 2.303 1.544 5.145 1.544"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F98",
    d: "M20.32 35.53s7.025.645 9.5-2.435v-3.54l-8.905.855z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB69F",
    d: "M25.69 33.68c5.664 0 10.255-5.87 10.255-13.11S31.354 7.46 25.69 7.46s-10.255 5.87-10.255 13.11 4.591 13.11 10.255 13.11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB69F",
    d: "M35.62 19.315s1.77-.215 1.93 1.47-.405 2.98-1.455 3.54c0 0-.225.11-.74.2l.265-5.205zM15.64 19.315s-1.77-.215-1.93 1.47.405 2.98 1.455 3.54c0 0 .225.11.74.2l-.265-5.205z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB69F",
    d: "M15.435 19.435S14.69 7.365 25.69 7.51v12.63z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB69F",
    d: "M35.94 19.435s.745-12.07-10.255-11.925v12.63z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB3F3A",
    d: "M18.66 17.94c1.69-.305 3.185-.065 3.945.08.23.045.46-.065.53-.255.08-.215-.07-.435-.33-.485-.865-.165-2.42-.415-4.05.155-.25.09-.695.335-.56.53.075.07.24.01.465-.03zM32.825 17.946c-1.69-.306-3.185-.066-3.945.08-.23.044-.46-.07-.53-.26-.08-.215.07-.44.33-.49.865-.17 2.42-.42 4.05.16.25.09.695.334.56.535-.075.07-.24.01-.465-.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#441D39",
    d: "M30.535 21.62c.334 0 .605-.47.605-1.05s-.27-1.05-.605-1.05-.605.47-.605 1.05.271 1.05.605 1.05M21.46 21.405c.334 0 .605-.47.605-1.05s-.27-1.05-.605-1.05-.605.47-.605 1.05.27 1.05.605 1.05"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F98",
    d: "M26.395 25.29h-.955c-.425 0-.8-.165-1-.44a.71.71 0 0 1-.115-.65c.22-.72.405-1.405.405-1.405a.25.25 0 0 1 .305-.175.244.244 0 0 1 .175.305s-.185.695-.41 1.42c-.02.075-.01.14.04.21.105.14.34.235.6.235h.955c.14 0 .25.11.25.25s-.11.25-.25.25M24.225 28.545c-.465 0-.77-.025-.805-.03a.247.247 0 0 1-.225-.27c.01-.14.135-.235.27-.23.03 0 2.85.23 4.94-.8a.25.25 0 1 1 .22.45c-1.53.755-3.365.875-4.395.875zM31.035 23.265c.964 0 1.745-.18 1.745-.4s-.781-.4-1.745-.4-1.745.179-1.745.4c0 .22.781.4 1.745.4M20.855 23.265c.964 0 1.745-.18 1.745-.4s-.781-.4-1.745-.4-1.745.179-1.745.4c0 .22.781.4 1.745.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C2642",
    d: "M30.415 37.15s-.145-1.68-.235-1.785c-2.255.715-6.51.636-9.825-.135 0 0-.285 1.12-4.45 4.056l-6.14 2.925L9.2 52.365h31.57L39.72 41.77l-9.3-4.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB3F3A",
    d: "M29.105 7.075c-.015-.025-.025-.055-.04-.075-.325-.54-5.33-.76-5.745-.63-.335.105-4.65 2.59-6.29 3.54-.405.235-.715.6-.875 1.04l-3.33 9.03c-.08.215-.12.445-.125.68l-.13 18.21c-.005 1.03-.56 1.71.465 1.815l4.51.515a2 2 0 0 0 2.14-1.485l.35-1.985c.12-.46-.02-.82.035-1.38.19-1.87-2.86-6.185-2.425-7.495.54-1.63 1.28-3.375 1.41-5.585s-1.3-6.11.715-10.85c1.62-3.81 5.38-3.05 6.79-2.605.105.035.215.055.325.07 0 0 8.1 2.51 8.31 11.52 0 0 .33.51.54-.09C37.18 17.15 35.305 7.97 29.1 7.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M35.93 23.77a.34.34 0 1 0 0-.68.34.34 0 0 0 0 .68"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "avatar-female_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "#fff",
    rx: 25
  })))));
};
export default SvgAvatarFemale;